__turbopack_context__.v({
  "content": "NothingFound-module-scss-module__ks6JaG__content",
  "root": "NothingFound-module-scss-module__ks6JaG__root",
  "subtitle": "NothingFound-module-scss-module__ks6JaG__subtitle",
  "title": "NothingFound-module-scss-module__ks6JaG__title",
});
